<template>
  <div>
    <h1>Welcome to the dices</h1>
    <p>Right now we are under construction</p>
    <p>URL: {{ pageconfig.tipo + " - " + pageconfig.id }}</p>
  </div>
</template>

<script>
    export default {
      name: "app-dices",
      props: {
        pageconfig: { type: Object, requite: true }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/app-dices.vue